import request from '../../utils/request'

// 位置信息的tab数据 get请求  id是拼接式使用
export function left1Data (data) {
  return request({
    method: 'get',
    url: 'dashboard/device_statistics',
    params: data
  })
}

// 获取项目设备告警信息
export function left2Data (data) {
  return request({
    method: 'get',
    url: 'dashboard/alarm_summary',
    params: data
  })
}

// 获取用水类型用水量
export function rightBoot1 (data) {
  return request({
    method: 'get',
    url: 'dashboard/water_usage_by_type',
    params: data
  })
}

// 获取区域用水量
export function rightBoot2 (data) {
  return request({
    method: 'get',
    url: 'dashboard/water_usage_by_region',
    params: data
  })
}

// 添加经纬度
export function addLatitude (data) {
  return request({
    method: 'post',
    url: 'dashboard/meter_location',
    data
  })
}

// 修改经纬度
export function modifyLatitude (data) {
  return request({
    method: 'post',
    url: 'dashboard/meter_location',
    data
  })
}

// 删除经纬度
export function deleteLatitude (data) {
  return request({
    method: 'post',
    url: 'dashboard/meter_location',
    data
  })
}

// 获取经纬度
export function getLatitude (data) {
  return request({
    method: 'get',
    url: 'dashboard/meter_location',
    params: data
  })
}

// 批量导入设备坐标信息
export function meterTableImport (data) {
  return request({
    method: 'post',
    url: 'dashboard/meter_location_bulk',
    data
  })
}
